import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  level?: 2 | 3 | 4;
  actions?: ReactNode;
  /** Hard-edged print offset shadow — primary cards only (design rule). */
  print?: boolean;
  tone?: 'default' | 'quiet';
  /** Agent working: travelling signal tape along the top edge. */
  working?: boolean;
}

export function Card({
  title,
  level = 2,
  actions,
  print,
  tone = 'default',
  working,
  className,
  children,
  ...rest
}: CardProps) {
  const H = `h${level}` as const;
  return (
    <section
      className={cx('fl-card', working && 'fl-tape', className)}
      data-print={print || undefined}
      data-tone={tone}
      aria-busy={working || undefined}
      {...rest}
    >
      {title || actions ? (
        <header className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
          {title ? <H className={level === 2 ? 'text-xl' : 'text-lg'}>{title}</H> : <span />}
          {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
